import {
  RELEASE_TENANT_REQUEST,
  RELEASE_TENANT_SUCCESS,
  RELEASE_TENANT_FAILURE,
  RESE_RELEASE_TENANT_SUCCESS
} from '../../../Constants/actionTypes';

const initialState = {
  releasing: false,
  releaseSuccess: false,
  releaseError: null,
  // other relevant state properties
};

const tenentBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case RELEASE_TENANT_REQUEST:
      return {
        ...state,
        releasing: true,
        releaseSuccess: false,
        releaseError: null,
      };
    case RELEASE_TENANT_SUCCESS:
      return {
        ...state,
        releasing: false,
        releaseSuccess: true,
        releaseError: null,
        // You can include additional properties from action.payload if needed
      };
    case RELEASE_TENANT_FAILURE:
      return {
        ...state,
        releasing: false,
        releaseSuccess: false,
        releaseError: action.payload,
      };
    case RESE_RELEASE_TENANT_SUCCESS:
      return {
        ...state,
        releaseError: null,
        releaseSuccess: false,
      };
    default:
      return state;
  }
};

export default tenentBookingReducer;
